export default {};
export const perfectScrollBarOptions = {
  wheelSpeed: 0.5,
  swipeEasing: false,
  suppressScrollX: true,
  wheelPropagation: false,
  scrollYMarginOffset: 10,
};
